import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useIsCreatorsPage = () => {
  const location = useLocation();
  const [isCreatorsPage, setIsCreatorsPage] = useState(false);

  useEffect(() => {
    if (location.pathname === "/creators") {
      setIsCreatorsPage(true);
    } else {
      setIsCreatorsPage(false);
    }
  }, [location.pathname]);

  return isCreatorsPage;
};
